var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCouponDownload02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#CCCCCC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 14.8125C26.1046 14.8125 27 15.7079 27 16.8125V24.8125C27 25.9171 26.1046 26.8125 25 26.8125H15C13.8954 26.8125 13 25.9171 13 24.8125V16.8125C13 15.7079 13.8954 14.8125 15 14.8125M20 13.1875L20.0001 22.5625M20.0001 22.5625L17 19.6989M20.0001 22.5625L23 19.6989",
    stroke: "black",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCouponDownload02);
export default __webpack_public_path__ + "static/media/icon_coupon_download02.05a34d4b644aa6a0020440c55e4cac17.svg";
export { ForwardRef as ReactComponent };